export default (state = [], action) => {
  switch (action.type) {
    case "CREATE_THERAPIST":
      return [...state, action.payload.therapist];
    case "UPDATE_THERAPISTS":
      return action.payload.therapists;
    case "DELETE_THERAPIST":
      return state.filter((therapist) => {
        return therapist.id !== action.payload.therapist.id
      });
    default:
      return state;
  }
}
